module.exports = __webpack_public_path__ + "media/assets/community/logo-online-courses-2f1e99e905515e844905553795f40e3363ace144f62aee47840d11ff3092d78a.png";